import React from 'react';
import { SpinnerCircular } from 'spinners-react';

const ConditionalWrapper = ({ shouldWrapChildren, children }) => {
  if(shouldWrapChildren) {
    return (
        <div className='flex-vertical-center fit-screen'>
            {children}
        </div>
    )
  } else {
    return children;
  }
}

export default function LoadingIcon(props) {
    const {
        fitScreen
    } = props;

    const color = props.color || "#03b6fc";
    const secondaryColor = props.secondaryColor || "#ffffff";
    const thickness= props.thickness || 200;

    return (
        <ConditionalWrapper
            shouldWrapChildren={fitScreen}
            children={<SpinnerCircular color={color} secondaryColor={secondaryColor} thickness={thickness} style={{margin: "0 auto!important"}} />}
        />
    )
}
